import {
  PRODUCT_BLOCKDEF_SNIPPET,
  SYSTEM_PRODUCTS_LOOP_SNIPPET,
  TEMPLATE_SYNTAX_REFERENCE_SNIPPET,
} from './templateCompileUtils';

export const VARIABLE_SECTIONS = [
  { id: 'overview', titleKey: 'catalog.templates.vars_section_overview' },
  { id: 'syntax', titleKey: 'catalog.templates.vars_section_syntax' },
  { id: 'mocks', titleKey: 'catalog.templates.vars_section_mocks' },
  { id: 'layout', titleKey: 'catalog.templates.vars_section_layout' },
];

const entry = (sectionId, id, title, opts = {}) => ({
  sectionId,
  id,
  title,
  path: opts.path ?? title,
  usageKey: opts.usageKey ?? '',
  example: opts.example ?? '',
  fields: opts.fields ?? [],
  keywords: opts.keywords ?? [],
  groupKey: opts.groupKey ?? '',
});

const LAYOUT_PAGE_EXAMPLE = `<main class="catalog-page">
  {{ block "hero" }}
  {{ block "products" }}
</main>`;

const LAYOUT_TAGS_EXAMPLE = `<print>Visível na impressão</print>
<noprint>Oculto na impressão</noprint>
<mobile>Só em telas pequenas</mobile>
<nomobile>Oculto no mobile</nomobile>
<crop length="200">{{ product.description }}</crop>`;

export const OVERVIEW_ENTRIES = [
  entry('overview', 'ex-products-block', 'Bloco de produtos (completo)', {
    usageKey: 'catalog.templates.vars_overview_ex_products_block',
    example: PRODUCT_BLOCKDEF_SNIPPET,
    fields: [
      'block.products (loop)',
      'product.title',
      'product.description',
      'product.images (loop)',
      'product.skus (loop)',
      'sku.label',
      'sku.code',
      'sku.price',
      'sku.has_price',
      'sku.attributes.{chave}',
    ],
    keywords: ['product_list', 'block.products', 'sku', 'atributos', 'preço'],
  }),
  entry('overview', 'ex-system-products', 'Loop system.products', {
    usageKey: 'catalog.templates.vars_overview_ex_system_products',
    example: SYSTEM_PRODUCTS_LOOP_SNIPPET,
    fields: ['system.products (loop)', 'product.skus (loop)', 'sku.attributes.{chave}'],
    keywords: ['system.products', 'composição', 'catálogo'],
  }),
  entry('overview', 'ex-layout', 'Layout da página', {
    usageKey: 'catalog.templates.vars_overview_ex_layout',
    example: LAYOUT_PAGE_EXAMPLE,
    keywords: ['layout', 'block', 'página'],
  }),
];

const SYNTAX_ENTRIES = [
  entry('syntax', 'syntax-reference', 'Sintaxe do template', {
    usageKey: 'catalog.templates.vars_syntax_reference',
    example: TEMPLATE_SYNTAX_REFERENCE_SNIPPET,
    keywords: ['for', 'if', 'blockdef', 'field', 'block', 'default', 'demo_count', 'chance'],
  }),
];

const MOCK_ENTRIES = [
  entry('mocks', 'mock-overview', 'mock.* no preview do template', {
    usageKey: 'catalog.templates.vars_mock_overview',
    example: '{{ field "title" type="text" default=mock.title() }}\n<p>{{ mock.text(size: "80") }}</p>',
    keywords: ['mock', 'default', 'preview'],
  }),
  entry('mocks', 'mock-common', 'mock.text / title / image', {
    usageKey: 'catalog.templates.vars_mock_common',
    example: '{{ mock.title() }}\n{{ mock.text(size: "120") }}\n{{ mock.image(size: "400x500") }}',
    keywords: ['mock', 'text', 'title', 'image'],
  }),
];

const LAYOUT_ENTRIES = [
  entry('layout', 'layout-tags', 'Tags de layout e impressão', {
    usageKey: 'catalog.templates.vars_layout_tags',
    example: LAYOUT_TAGS_EXAMPLE,
    keywords: ['print', 'mobile', 'crop', 'layout'],
  }),
];

export const buildVariableCatalog = () => ({
  sections: VARIABLE_SECTIONS,
  entries: [...OVERVIEW_ENTRIES, ...SYNTAX_ENTRIES, ...MOCK_ENTRIES, ...LAYOUT_ENTRIES],
});

export const filterVariableEntries = (entries, query) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return entries;
  return entries.filter((row) => {
    const haystack = [
      row.title,
      row.path,
      row.id,
      row.groupKey,
      row.example,
      ...(row.keywords || []),
      ...(row.fields || []),
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
};

export const groupEntriesBySection = (entries) => {
  const map = new Map();
  VARIABLE_SECTIONS.forEach((section) => {
    map.set(section.id, []);
  });
  entries.forEach((row) => {
    const list = map.get(row.sectionId);
    if (list) list.push(row);
  });
  return map;
};
